import { AxiosResponse } from "axios";
import http from "../../http-common";

import {
    Activity,
    ActivityListDTO,
    ActivityPostDTO,
    TradeLinkDTO,
} from "../../types/Quality/Activity";

export const getActivities = async () => {
    let response = { data: null, status: 0, statusText: '', headers: {}, config: {} } as AxiosResponse;
    const activityList: Activity[] = [];
    try {
        /**
         * This loop should, in general, be unnecessary.  It is here for completeness
         */
        let page: number | null = 1;
        do {
            const url = `/listActivities?Page=${page}`;
            response = await http.get<ActivityListDTO>(url);
            const { nextPage, items } = response.data;
            activityList.push(...items);
            page = nextPage;
        } while (page !== null);

        response.data.items = activityList;
    } finally {
      // we are skipping the catch here on purpose
      //  we want to allow this pass even though it may be empty
      return response;
    }
};

export const unlinkTradeFromActivity = async (activityId: number, tradeId: number, userEmail: string) => {
    let response = { data: null, status: 0, statusText: '', headers: {}, config: {} } as AxiosResponse;
    try {
        response = await http.post<TradeLinkDTO>('/unlinkTradeFromActivity', { activityId, tradeId, userEmail });
    } finally {
      // we are skipping the catch here on purpose
      //  we want to allow this pass even though it may be empty
      return response;
    }
};

export const linkTradeToActivity = async (activityId: number, tradeId: number, userEmail: string) => {
    let response = { data: null, status: 0, statusText: '', headers: {}, config: {} } as AxiosResponse;
    try {
        response = await http.post<TradeLinkDTO>('/linkTradeToActivity', { activityId, tradeId, userEmail });
    } finally {
      // we are skipping the catch here on purpose
      //  we want to allow this pass even though it may be empty
      return response;
    }
};

export const renameActivity = async (activityId: number, newName: string, rowVersionBase64: string, userEmail: string) => {
    let response = { data: null, status: 0, statusText: '', headers: {}, config: {} } as AxiosResponse;
    try {
        response = await http.post<ActivityPostDTO>('/renameActivity', { activityId, newName, rowVersionBase64, userEmail });
    } finally {
      // we are skipping the catch here on purpose
      //  we want to allow this pass even though it may be empty
      return response;
    }
};

export const createActivity = async (name: string, userEmail: string) => {
    let response = { data: null, status: 0, statusText: '', headers: {}, config: {} } as AxiosResponse;
    try {
        response = await http.post<ActivityPostDTO>('/createActivity', { name, userEmail });
    } finally {
      // we are skipping the catch here on purpose
      //  we want to allow this pass even though it may be empty
      return response;
    }
};